<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/system-setup/organizations"></back-button>
          Update Organization
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">System Setup</li>
          <li class="breadcrumb-item">
            <router-link :to="`/system-setup/organizations`"
              >Organizations</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <organization-form :form="form"></organization-form>
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import organizationForm from "./organization-form.vue";

export default {
  components: { organizationForm },
  name: "OrganizationUpdate",
  data() {
    return {
      form: {
        country_id: "",
        city_id: "",
      },
      countries: [],
      cities: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("organizations/masters");
      masters = masters.data;
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
      masters.cities.forEach((city) => {
        this.cities.push({
          id: city.id,
          name: city.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/organizations/${this.$route.params.organizationId}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(
          `/organizations/${this.$route.params.organizationId}`,
          this.form
        );
        await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/system-setup/organizations");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      let attachment = this.$refs.file?.files[0];
      const id = this.form.id;
      let formData = new FormData();
      formData.append("id", id);
      formData.append("logo", attachment);
      await axios
        .post("upload_organization_logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      if (this.career_request) {
        this.success = true;
        this.form = [];
      }
      this.isLoading = false;
    },
  },
};
</script>
